
import { Button, Grid, Typography, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../../../styles/report.css'
import PreviousAssessmentDonutChart from './PreviousAssessmentDonutChart';
import CircleIcon from '@mui/icons-material/Circle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useNavigate, createSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { surveyClear } from "../../../reducers/survey"

const PreviousAssessmentContainer = (props) => {
    const PreviousAssessmentArray = props.PreviousAssessments

    const [currentIndex, setCurrentIndex] = useState(0)
    const [currentAssessment, setCurrentAssessment] = useState(PreviousAssessmentArray && PreviousAssessmentArray.length > 0 ? PreviousAssessmentArray[currentIndex] : {})
    const { user: currentUser } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const assessmentGuid = currentAssessment.AssmtGuid;
    const dispatch = useDispatch();


    const handleCircleClick = (val) => {
        setCurrentIndex(val)
        setCurrentAssessment(PreviousAssessmentArray[val])
    }

    const handlePRClick = (guid) => {


        if (assessmentGuid) {
            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + assessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337' }).toString() })
                })
        }
    }

    const handlePSClick = (guid) => {

        if (assessmentGuid) {
            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + assessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/physiciansummary', search: createSearchParams({ vi: '2C2870C1-1C00-4E67-98FF-04BA402C6824' }).toString() })
                })
        }
    }

    const handleEditClick = (guid) => {


        if (assessmentGuid) {
            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + assessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    dispatch(surveyClear())
                    navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701', assmtguid: assessmentGuid }).toString() })
                })

        }
    }

    useEffect(() => {

    }, [currentAssessment])

    return (
        <div>

            <Grid container direction="row" alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Typography variant="subtitle1" align='center'>{currentAssessment.Date}</Typography>
                </Grid>
                <Grid item xs={12} alignItems="center" >
                    <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                        <Box sx={{ maxWidth: "115px" }}>
                            <PreviousAssessmentDonutChart key={currentIndex} OWSText={'test'} CurrentOWSValue={currentAssessment.Ows} />
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={8}>
                            <Box sx={{ alignItems: "right", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                                <Button onClick={() => handleEditClick(currentAssessment.AssmtGuid)}
                                    disabled={currentAssessment.EditAssessmentVisible === '0'}
                                    variant="gradiant">{currentAssessment.EditAssessmentText}
                                </Button>
                            </Box>
                        </Grid>
                        {currentAssessment.PrViGuid && (

                            <Grid item xs={12} sm={6}>
                                <Box sx={{ alignItems: "right", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                                    <Button onClick={() => handlePRClick(currentAssessment.AssmtGuid)}
                                        variant="gradiant">{currentAssessment.GetPersReptText}
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                        {currentAssessment.PsViGuid && (

                            <Grid item xs={12} sm={6}>
                                <Box sx={{ alignItems: "left", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                                    <Button onClick={() => handlePSClick(currentAssessment.AssmtGuid)}
                                        variant="gradiant">{currentAssessment.GetPhySummText}
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                <Grid xs={12}>
                    <Box sx={{ display: "flex", direction: "row", alignItems: "center", justifyContent: "center" }} mb={2}>
                        {
                            PreviousAssessmentArray.map((x, i) => {
                                return (
                                    i === currentIndex ? <CircleIcon sx={{ color: "#000000" }} /> : <RadioButtonUncheckedIcon onClick={() => handleCircleClick(i)} />
                                )
                            })
                        }
                    </Box>
                </Grid>
            </Grid>
        </div >

    )
}

export default PreviousAssessmentContainer;